import React from 'react';
import { useReveal } from '../lib/useReveal';

export const About = ({ data, language = 'bg' }) => {
  const headRef = useReveal();
  const imgRef = useReveal();
  const listRef = useReveal();

  const items = [...(data?.Why || []), ...(data?.Why2 || [])];
  const altText = language === 'bg'
    ? 'Производство на дограма в работилницата на ДВ Пласт'
    : 'Window frame production at the DV Plast workshop';

  return (
    <section id="za_nas" className="section-pad bg-paper text-ink relative">
      <div className="max-wrap section-wrap">
        <div ref={headRef} className="reveal grid grid-cols-12 gap-y-6 gap-x-6 items-end">
          <div className="col-span-12 lg:col-span-3">
            <span className="font-mono text-index text-ink-muted">01 / 04</span>
            <span className="block mt-4 h-px w-16 bg-ink/60" aria-hidden="true" />
          </div>

          <div className="col-span-12 lg:col-span-9">
            <h2 className="font-serif text-balance tracking-tightest leading-[0.98]"
                style={{ fontSize: 'clamp(2.25rem, 8vw, 6rem)' }}>
              {data?.title || (language === 'bg' ? 'Относно компанията' : 'About the company')}
            </h2>
          </div>
        </div>

        <div className="mt-16 md:mt-24 grid grid-cols-12 gap-y-14 gap-x-6 md:gap-x-10 lg:gap-x-16">
          <div ref={imgRef} className="reveal col-span-12 md:col-span-6 lg:col-span-5">
            <div className="relative">
              <div className="aspect-[4/5] overflow-hidden bg-paper-deep">
                <img
                  src="/img/about.webp"
                  alt={altText}
                  loading="lazy"
                  decoding="async"
                  width="1051"
                  height="1332"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          <div className="col-span-12 md:col-span-6 lg:col-span-7 lg:pl-8">
            {data?.paragraph && (
              <p className="font-serif text-pretty text-ink leading-[1.2] tracking-tight"
                 style={{ fontSize: 'clamp(1.5rem, 3.2vw, 2.5rem)' }}>
                {data.paragraph}
              </p>
            )}

            {data?.why && (
              <div className="mt-12 flex items-baseline gap-4">
                <span className="font-mono text-[0.68rem] uppercase tracking-[0.22em] text-ink-muted">
                  {data.why}
                </span>
                <span className="flex-1 h-px bg-rule" aria-hidden="true" />
              </div>
            )}

            <ul ref={listRef} className="reveal mt-2 grid grid-cols-1 sm:grid-cols-2 gap-x-10">
              {items.map((item, i) => (
                <li
                  key={i}
                  className="flex items-baseline gap-5 py-4 border-b border-rule"
                >
                  <span className="font-mono text-[0.7rem] tabular-nums tracking-[0.2em] text-ink-faint">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span className="text-base sm:text-lg text-ink-soft leading-snug">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
